function isMaintenanceMode(): boolean {
  return import.meta.env.VITE_MAINTENANCE_MODE === "true";
}

export { isMaintenanceMode };
